import DocumentLine from "./DocumentLine";

export default function DocumentLines({ items }: any) {
  return (
    <div className="border border-black  my-2 text-xs">
      <div className="grid grid-cols-12 border-b  border-black  bg-gray-200">
        <div className="col-span-2 p-1 font-bold border-r border-black  text-left">
          Date
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Doc No.
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Description
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Value
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Paid
        </div>
        <div className="col-span-2 p-1 font-bold text-center">Balance</div>
      </div>
      <div className="">
        {items.map((item: any, i: any) => (
          <DocumentLine
            style={{ color: "red" }}
            key={i + item._id}
            index={i}
            entries={[]}
            parts={[]}
            service_id={1}
            item={item}
          />
        ))}
      </div>
    </div>
  );
}
